import type { Time } from '@core/time/time';
import type { Class } from '@engage/classes/models';
import type { Instructor } from '@engage/metadata/models';
import type {
  EffortZonesData,
  DeviceType,
  Workout,
  ClassWorkout,
  FreestyleWorkout,
} from '@engage/workouts/models';
import { isClassWorkout } from '@engage/workouts/models';

type DeviceTypeProviding = {
  deviceType: DeviceType;
};

type InstructorProviding = {
  instructor: Instructor;
};

export type Displayable<T extends {}> = T &
  (T extends DeviceTypeProviding ? { displayable: DeviceTypeProviding } : {});

export type HydratedWorkout = HydratedClassWorkout | HydratedFreestyleWorkout;
export type DisplayableWorkout = Displayable<Workout>;
export type WorkoutWithClass = ClassWorkout & { class: Class & InstructorProviding };
type HydratedFreestyleWorkout = DisplayableWorkout & Workout & FreestyleWorkout;
type HydratedClassWorkout = DisplayableWorkout & WorkoutWithClass;

export type WorkoutHistoryItem = {
  classTitle: string;
  fitnessDiscipline: string;
  hasMetrics: boolean;
  imageUrl: string;
  id: string;
  instructorName: string;
  isScenic: boolean;
  output: number;
  deviceType: string;
  scheduledStartTime?: Time;
  deviceTimeCreatedAt: Time;
  userId: string;
  effortZones: EffortZonesData | null;
  isNonPartner3pFitFeedWorkout?: boolean;
};

export const hasClass = (workout: HydratedWorkout): workout is HydratedClassWorkout =>
  !!isClassWorkout(workout);
